import { stats } from "../../../mocks/communityData";

export default function Hero() {
  return (
    <section id="home" className="relative overflow-hidden pt-16">
      {/* 背景装饰 */}
      <div className="watermelon-dots absolute inset-0 -z-10" />
      <div className="absolute -right-24 -top-24 -z-10 h-80 w-80 rounded-full bg-primary-100 blur-2xl" />
      <div className="absolute -left-20 top-40 -z-10 h-72 w-72 rounded-full bg-accent-100 blur-2xl" />

      <div className="mx-auto grid w-full max-w-6xl items-center gap-10 px-4 py-14 md:px-6 md:py-20 lg:grid-cols-2">
        {/* 左文案 */}
        <div className="w-full">
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-200 bg-accent-50 px-4 py-1.5 text-sm font-medium text-accent-700">
            <i className="ri-flashlight-fill text-base text-accent-500" />
            免费吃瓜社区 · 聚集地
          </span>

          <h1 className="mt-6 font-display text-4xl leading-tight text-foreground-900 md:text-5xl lg:text-6xl">
            瓜友聚集
            <br />
            讨论<b className="text-primary-500">不冷场</b>
          </h1>

          <p className="mt-5 max-w-lg text-base leading-relaxed text-foreground-600 md:text-lg">
            这里是免费吃瓜同好的线上聚集地。分享最新瓜料、围观热门话题、一起畅聊不孤单。热门话题天天有，
            <span className="font-semibold text-foreground-900">随时加入随时聊</span>，欢迎常来玩！
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <a
              href="#hot"
              className="rounded-full bg-primary-500 px-7 py-3 text-base font-bold text-white shadow-sm transition hover:bg-primary-600 whitespace-nowrap"
            >
              <i className="ri-fire-line mr-1.5 align-middle" />
              去看看今日瓜榜
            </a>
            <a
              href="#column"
              className="rounded-full border border-background-300 bg-background-50 px-7 py-3 text-base font-semibold text-foreground-700 transition hover:border-primary-300 hover:text-primary-500 whitespace-nowrap"
            >
              挑选我的栏目
            </a>
          </div>

          {/* 数据统计 */}
          <div className="mt-10 grid grid-cols-2 gap-x-6 gap-y-6 sm:grid-cols-4">
            {stats.map((item, i) => (
              <div key={i} className="flex flex-col">
                <span className={`font-display text-3xl ${i % 2 === 0 ? "text-primary-500" : "text-accent-600"}`}>
                  {item.value}
                </span>
                <span className="mt-1 text-sm text-foreground-500">{item.label}</span>
              </div>
            ))}
          </div>
        </div>

        {/* 右视觉 */}
        <div className="relative mx-auto w-full max-w-md lg:max-w-none">
          <div className="seed-stripe h-3 w-full rounded-full" />
          <div className="relative mt-4 overflow-hidden rounded-3xl">
            <img
              src="https://readdy.ai/api/search-image?query=group%20of%20happy%20young%20friends%20chatting%20and%20laughing%20around%20a%20table%20with%20phones%20and%20snacks%2C%20warm%20cozy%20lighting%2C%20casual%20community%20gathering%20vibe%2C%20bright%20friendly%20atmosphere&width=800&height=720&seq=hero-main&orientation=landscape"
              alt="吃瓜同好们聚集一起轻松讨论热门话题"
              className="h-72 w-full object-cover md:h-96"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/20 to-transparent" />
          </div>

          {/* 浮动卡片 */}
          <div className="animate-float-slow absolute -left-3 top-6 flex items-center gap-2 rounded-2xl bg-background-50 px-4 py-2.5 shadow-sm">
            <span className="flex h-7 w-7 items-center justify-center rounded-full bg-accent-100 text-accent-600">
              <i className="ri-chat-heart-line" />
            </span>
            <span className="text-sm font-semibold text-foreground-700">同好在线中…</span>
          </div>
          <div className="animate-wiggle absolute -right-2 bottom-10 flex items-center gap-2 rounded-2xl bg-background-50 px-4 py-2.5 shadow-sm">
            <i className="ri-fire-fill text-lg text-primary-500" />
            <span className="text-sm font-semibold text-foreground-700">今日热聊 3200+</span>
          </div>
        </div>
      </div>
    </section>
  );
}